import React from "react";
import BlockingPopup from "../components/BlockingPopup";

interface BlockingPopupContainerProps {}

interface BlockingPopupContainerState {
  isPopupActive: boolean;
}

export default class BlockingPopupContainer extends React.Component<
  BlockingPopupContainerProps,
  BlockingPopupContainerState
> {
  constructor(props: BlockingPopupContainerProps) {
    super(props);
    this.state = {
      isPopupActive: true,
    };
  }

  componentDidMount(): void {}

  deActivatePopup = () => {
    if (this.state.isPopupActive) {
      this.setState({
        isPopupActive: false,
      });
      document.getElementById("modelPage").classList.remove("isBlurred");
    }
  };

  activatePopup = () => {
    if (!this.state.isPopupActive) {
      this.setState({
        isPopupActive: true,
      });
    }
  };

  render() {
    return (
      <BlockingPopup
        isActive={this.state.isPopupActive}
        deActivatePopup={this.deActivatePopup}
        popupBlockerCtaUrl={window["popupBlockerCtaUrl"]}
        popupBlockerCtaName={window["popupBlockerCtaName"]}
        popupBlockerCtaTarget={window["popupBlockerCtaTarget"]}
        popupBlockerTitle={window["popupBlockerTitle"]}
        popupBlockerContent={window["popupBlockerContent"]}
        popupBlockerDisclaimer={window["popupBlockerDisclaimer"]}
        popupBlockerBackgroundImageDesktop={
          window["popupBlockerBackgroundImageDesktop"]
        }
        popupBlockerBackgroundImageMobile={
          window["popupBlockerBackgroundImageMobile"]
        }
        allowUserToClosePopupBlocker={window["allowUserToClosePopupBlocker"]}
      />
    );
  }
}
